import { combineReducers } from 'redux';
import { PaymentModeReducer } from './changePayModeBusiness';
import { MemberReducer } from './memberReducer';

const rootReducer = combineReducers({
  PaymentModeReducer: PaymentModeReducer,
  MemberReducer: MemberReducer
})

export default rootReducer
